export default __webpack_public_path__ + "static/media/slide14.bc93eb9b.jpg";